import React from 'react';
import { connect } from 'react-redux';
import PageHeaderWrapper from '../../components/PageHeaderWrapper';
import { Card, DatePicker, Row, Col, Button } from 'antd';
import { TableComp } from 'sz-react-utils';
import Request from '../../request';
import moment from 'moment';
import rightAuth from '../../components/_utils/userRights';
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const { MonthPicker, RangePicker } = DatePicker;
class VisitorVisaReport extends React.Component {
    state = {
        loading: false,
        total: 0,
        totalAmount: 0,
        paymentYearMonth: moment().format('YYYY-MM'),
        time: null,
        branches: [],
        counsellors: [],
        countries: [],
        enquiryStatus: [],
        visaStatus: [],
        exportParams: {}
    }

    loadFilters = async () => {
        let { branches, counsellors, countries, enquiryStatus, visaStatus } = await Request.getVisitorReportFilters();
        this.setState({ branches, counsellors, countries, enquiryStatus: enquiryStatus.filter(x => x != null), visaStatus: visaStatus.filter(x => x != null) })
    }

    componentDidMount() {
        this.loadFilters();
    }

    exportExcel = async () => {
        let params = this.state.exportParams
        let x = await Request.exportVisitorVisaReport({
            ...params,
            regExFilters: ['name']
        })
        if (!x.error) {
            window.open(x.url)
        }
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            if (this.state.paymentYearMonth) {
                params.paymentYearMonth = this.state.paymentYearMonth;
            }
            if (params.receiptDate) {
                params.time = {
                    from: moment(params.receiptDate, dateFormat).startOf('day').toDate(),
                    to: moment(params.receiptDate, dateFormat).endOf('day').toDate(),
                }
                delete params.receiptDate
            }
            if (this.state.time) {
                params.time = this.state.time;
            }


            this.setState({ loading: true, exportParams: params });
            let response = await Request.getVisitorVisaReport(params);
            this.setState({ total: response.total, loading: false, totalAmount: response.totalAmount });
            return resolve(response);
        })
    }
    reload = () => {
        this.table.current.reload();
    }

    onChange = (date, dateString) => {
        if (!date) {
            // Handle clearing the picker
            this.setState({ paymentYearMonth: null }, () => {
                this.reload();
            });
        } else {
            this.setState({ paymentYearMonth: dateString }, () => {
                this.reload();
            });
        }

    };

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    chooseRangerPicker = (date, dateString) => {
        if (!date || !date.length) {
            this.setState({
                time: null
            }, () => {
                this.reload()
            })
        } else {
            this.setState(
                {
                    time: {
                        from: moment(date[0]).startOf('day').toDate(),
                        to: moment(date[1]).endOf('day').toDate(),
                    }, paymentYearMonth: null
                }, () => {
                    this.reload();

                }
            )
        }

    }

    onOk = value => {
        this.reload();
    }


    render() {
        let { total, loading, totalAmount, paymentYearMonth, branches, counsellors, countries, enquiryStatus, visaStatus } = this.state
        const columns = [
            {
                title: '#',
                key: 'serialNumber',
                width: 50,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'V.I.D',
                key: 'id',
                width: 80,
                dataIndex: 'visaInquiryId.id',
                searchTextName: 'V.I.D'
            },
            {
                title: 'Payment Date',
                key: 'receiptDate',
                dataIndex: 'receiptDate',
                searchTextName: `${dateFormat}`,
                render: (text, record) => (
                    <div>{moment(record.receiptDate).format(dateFormat)}</div>
                )
            },
            {
                title: 'Applicant Name',
                key: 'applicantName',
                dataIndex: 'visaInquiryId.applicantName',
                searchTextName: 'Applicant Name',
            },
            {
                title: 'Mobile Number',
                key: 'mobileNumber',
                dataIndex: 'visaInquiryId.mobileNumber',
                searchTextName: 'Mobile Number',
            },
            {
                title: 'Country',
                key: 'countryId',
                dataIndex: 'countryId.countryName',
                filters: countries.map(x => ({ value: x._id, text: x.countryName })),
            },
            {
                title: 'Counsellor',
                key: 'userId',
                dataIndex: 'userId.name',
                filters: counsellors.map(x => ({ value: x._id, text: x.name })),
            },
            {
                title: 'Inquiry Status',
                key: 'enquiryStatus',
                dataIndex: 'visaInquiryId.enquiryStatus',
                filters: enquiryStatus.map(x => ({ value: x, text: x })),
            },
            {
                title: 'Visa Status',
                key: 'visaStatus',
                dataIndex: 'visaInquiryId.visaStatus',
                filters: visaStatus.map(x => ({ value: x, text: x })),
            },
            {
                title: 'Branch',
                key: 'branchId',
                dataIndex: 'branchId.branchName',
                filters: branches.map(x => ({ value: x._id, text: x.branchName })),
            },
            {
                title: 'Amount Received',
                key: 'totalAmount',
                dataIndex: 'totalAmount',
                searchTextName: 'Amount',
            }

        ]
        return (
            <PageHeaderWrapper title={`Visitor Visa Report - ${total}`}>
                <Card bordered={true} style={{ marginBottom: 10 }}>
                    <Row gutter={16}>
                        <Col span={6}>
                            <h4>Filter By Month</h4>
                            <MonthPicker value={paymentYearMonth ? moment(paymentYearMonth, 'YYYY-MM') : null} format={'YYYY-MM'} placeholder='Select Month' onChange={this.onChange} />
                        </Col>
                        <Col span={6}>
                            <h4>Filter by Date</h4>
                            <RangePicker
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                        <Col span={4}>
                            {
                                rightAuth.checkRights("visitorVisaReportExport.view") ?
                                    <Button type={'default'}
                                        style={{ marginTop: 20 }}
                                        onClick={() => {
                                            this.exportExcel()
                                        }}>Export Excel</Button>
                                    : null
                            }
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <h4>Amount Total:- {totalAmount}</h4>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        loading={loading}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

            </PageHeaderWrapper>
        )
    }
}



const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VisitorVisaReport)

